export const AvatarSearch: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="280" height="280" viewBox="0 0 280 280" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF6D9"
        d="M0 124.977c0 68.958 55.709 124.86 124.43 124.86 68.578 0 124.2-55.668 124.43-124.429v-.862C248.63 55.786 193.008.117 124.43.117 55.71.117 0 56.02 0 124.977"
        transform="translate(15 15)"
      />
      <path
        fill="#002F34"
        d="M124.43 160.563c37.985 0 70.788 22.268 86.151 54.504-22.356 21.536-52.713 34.77-86.15 34.77l-2.059-.017c-32.624-.53-62.196-13.66-84.094-34.751 15.364-32.239 48.166-54.506 86.152-54.506z"
        transform="translate(15 15)"
      />
      <path
        fill="#FFCE32"
        d="M196.977 111.72c0 40.587-32.481 73.489-72.546 73.489-40.067 0-72.547-32.902-72.547-73.488 0-40.587 32.48-73.488 72.547-73.488 40.065 0 72.546 32.9 72.546 73.488"
        transform="translate(15 15)"
      />
      <path
        fill="#002F34"
        d="M124.43 38.232l1.2.01c32.268.53 59.414 22.4 68.284 52.287a47.128 47.128 0 01-24.095 6.59c-21.08 0-38.976-13.818-45.339-33-10.536 26.217-38.857 41.14-66.655 33.85a56.88 56.88 0 01-4.408-1.348c6.874-33.344 36.057-58.39 71.013-58.39zM101.14 118.806c0 4.52-3.65 8.182-8.153 8.182-4.504 0-8.154-3.662-8.154-8.182 0-4.518 3.65-8.181 8.154-8.181 4.502 0 8.153 3.663 8.153 8.181"
        transform="translate(15 15)"
      />
      <path
        fill="#002F34"
        d="M153.368 29.155c0 16.037-12.956 29.038-28.938 29.038s-28.938-13-28.938-29.038c0-16.037 12.956-29.038 28.938-29.038s28.938 13 28.938 29.038"
        transform="translate(15 15)"
      />
      <path
        fill="#D2B982"
        d="M196.122 224.627L201.386 212.137 202.538 209.403 183.96 163.346 162.38 172.11 180.959 218.167 187.29 220.863z"
        transform="translate(15 15)"
      />
      <path
        fill="#FFCE32"
        d="M199.671 192.151c8.924 0 16.793 4.53 21.45 11.421-10.9 13.486-24.544 24.646-40.08 32.624a25.955 25.955 0 01-7.27-18.055c0-14.353 11.596-25.99 25.9-25.99z"
        transform="translate(15 15)"
      />
      <path
        fill="#D2B982"
        d="M206.045 106.735c10.844 26.576-2.085 56.841-28.876 67.599-26.792 10.756-57.302-2.068-68.147-28.645-10.844-26.576 2.085-56.841 28.876-67.599 26.793-10.756 57.303 2.067 68.147 28.645"
        transform="translate(15 15)"
      />
      <path
        fill="#FFEDB2"
        d="M183.972 95.466c17.095 14.418 19.17 39.855 4.635 56.813-14.535 16.958-40.177 19.017-57.273 4.599-17.095-14.42-19.172-39.855-4.635-56.813 14.535-16.96 40.178-19.018 57.273-4.6"
        transform="translate(15 15)"
      />
      <path
        fill="#002F34"
        d="M174.772 126.14c0 9.653-7.825 17.477-17.477 17.477-9.654 0-17.477-7.824-17.477-17.477 0-9.652 7.823-17.477 17.477-17.477 9.652 0 17.477 7.825 17.477 17.477"
        transform="translate(15 15)"
      />
    </g>
  </svg>
);
